import { render, staticRenderFns } from "./RatingsViewer.vue?vue&type=template&id=fba0206e&scoped=true"
import script from "./RatingsViewer.vue?vue&type=script&lang=ts"
export * from "./RatingsViewer.vue?vue&type=script&lang=ts"
import style0 from "./RatingsViewer.vue?vue&type=style&index=0&id=fba0206e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0206e",
  null
  
)

export default component.exports